import * as React from 'react';
import NewCloseButton from './NewCloseButton';
import { zIndex } from '../../constants';
import { getBasePath } from '../../utils/browser';

interface NewSettingPopupProps {
  title: string;
  imgName?: string;
  onClose: () => void;
  renderOutsideLeft?: () => JSX.Element;
}

const backdropStyle: React.CSSProperties = {
  position: 'fixed',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.25)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: zIndex.settingPopup,
};

const wrapperStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
};

const dialogStyle: React.CSSProperties = {
  position: 'relative',
  border: '2px solid #363636',
  borderRadius: '6px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  background: '#f9f8f4',
  color: 'black',
};

const headerStyle: React.CSSProperties = {
  background: '#807b74',
  paddingLeft: '20px',
  paddingRight: '6px',
  color: '#fff',
  height: '43px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

const titleImageStyle: React.CSSProperties = {
  height: '40px',
  width: 'auto',
};

// 今後ドラッグで動かすかもしれないからSFCじゃなくてPureComponent
class NewSettingPopup extends React.PureComponent<NewSettingPopupProps> {
  public render() {
    const { renderOutsideLeft, imgName, title } = this.props;
    const baseDir = getBasePath();
    const imgSrc = `${baseDir}/images/setting-popup/title/${imgName}.png`;
    const canImage = imgName != null;

    return (
      <aside style={backdropStyle} onClick={this.props.onClose}>
        <div style={wrapperStyle}>
          {renderOutsideLeft && renderOutsideLeft()}
          <div style={dialogStyle} onClick={(ev) => { ev.stopPropagation(); }}>
            <header style={headerStyle}>
              {canImage ? <img src={imgSrc} style={titleImageStyle} /> : <h2>{title}</h2>}
              <NewCloseButton onClick={this.props.onClose} />
            </header>
            <div>
              {this.props.children}
            </div>
          </div>
        </div>
      </aside>
    );
  }
}

export default NewSettingPopup;
